<div id="gen-loading" *ngIf="videoUploading" >
    <div class="loader-inner text-center">
        
         <img class="img-fluid logo mobile-hide-log" width="100px" src="https://app.funtelstudio.com/storage/uploads/settings/app_logo_U0iNFBBT69LqaizVZG7H2ofsuu4cFOVAfk2I6Vj7iprY1wOI4NaHDaCpRTg78zTD.png" alt="streamlab-image">
        <p class="mb-0 loading-content text-light mt-2">Uploading video, please wait...</p>
        <div class="loader-spinner"></div>
    </div>
</div>

<app-header></app-header>   

<main class="container mx-auto px-4 lg:px-6 pb-20">
  <!-- Success Message -->
  <div *ngIf="successMessage" class="p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg">
    {{ successMessage }}
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg">
    {{ errorMessage }}
  </div>

  <form [formGroup]="storyForm" (ngSubmit)="onSubmit()">
    <!-- Story Editor Section -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm mb-6">
      <!-- Part Title -->
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <input 
  #titleInput
  type="text" 
  formControlName="story_title" 
  placeholder="Untitled Part"  
  class="w-full text-2xl font-bold bg-transparent focus:outline-none focus:ring-0 p-0"
  (input)="onTitleInput($event)"
  (keydown)="onTitleKeydown($event)"
>
      </div>
     <div class="language-selector">
  
</div>

<editor 
  formControlName="story_content" 
  (onInit)="onEditorInit($event)"
  [init]="{
    menubar: false,
    toolbar: 'bold italic underline',
    content_style: 'body { font-family: Arial, sans-serif; font-size: 16px; }'
  }"
></editor>

    </div>

    <div class="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-sm">
      <div class="flex items-center justify-between">
       
<div class="flex items-center space-x-4">


                </div>
        <div class="flex flex-wrap gap-3">
                    <button (click)="publishStory()"
                        class="pointer px-6 py-2 rounded-full font-medium bg-wattpad-primary text-white hover:bg-[#E5274B] transition-colors"
                        type="button">
                        <i class="fas fa-upload mr-2"></i> Publish
                    </button>
                    <button type="submit"
                        class="px-6 py-2 rounded-full font-medium border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <i class="fas fa-save mr-2"></i> Save Draft
                    </button>


                    <!-- <button id="previewBtn" class="px-6 py-2 rounded-full font-medium border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <i class="fas fa-eye mr-2"></i> Preview
                    </button> -->
                </div>
      </div>
    </div>
  </form>
</main>